import React from "react";
import { Route, Routes } from "react-router";
import Properties from "./properties";
import Edit from "./forms/edit";
import Create from "./forms/create";
import Expiring from "./expiring";

export default function Inventory() {
  return (
    <div>
      <div className="border-b border-zinc-300 pb-3 ">
        <div className="ml-12 border-l border-zinc-300 pl-4">
          <h1 className="text-2xl font-bold leading-tight tracking-tight text-zinc-800">
            Propiedades
          </h1>
        </div>
      </div>
      <Routes>
        <Route path="/" element={<Properties />} />
        <Route path="edit/:propertyId" element={<Edit />} />
        <Route path="create" element={<Create />} />
        <Route path="expiring" element={<Expiring />} />
      </Routes>
    </div>
  );
}
